import { render, staticRenderFns } from "./baseConfig.vue?vue&type=template&id=3afc7b1e&scoped=true&"
import script from "./baseConfig.vue?vue&type=script&lang=js&"
export * from "./baseConfig.vue?vue&type=script&lang=js&"
import style0 from "./baseConfig.vue?vue&type=style&index=0&id=3afc7b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc7b1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3afc7b1e')) {
      api.createRecord('3afc7b1e', component.options)
    } else {
      api.reload('3afc7b1e', component.options)
    }
    module.hot.accept("./baseConfig.vue?vue&type=template&id=3afc7b1e&scoped=true&", function () {
      api.rerender('3afc7b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/webConfig/baseConfig.vue"
export default component.exports